export default "__VITE_ASSET__2I1K$6x4__"